import { message as Message } from 'antd';

if (Message && typeof Message.config === 'function') {
  Message.config({
    top: 64,
    duration: 2,
  });
}

/** @function */
export default Message;
